// Widget extensions
//
// In your application include widget extensions. Using require.js:
// define(["canvas/"widget-extensions], function(ext) { ... });
//
// add properties to ext that you need in all widgets.
// ext.hello = function() { alert("hello world")};
//
// and use in all widgets:
// my.hello();

const extensions = {};

export default extensions;
